import { IMaterial } from '@interfaces/IMaterial';

export interface IMaterialsState {
  materials: IMaterial[];
  currentMaterial: IMaterial | null;
  loading?: {
    updateMaterial?: boolean;
    getMaterial?: boolean;
    getMaterials?: boolean;
    delete?: boolean;
    addMaterial?: boolean;
  };
  success: boolean;
  count: number;
}

export const initialMaterialsState: IMaterialsState = {
  materials: [],
  count: 0,
  success: false,
  currentMaterial: null,
};
